import { atom } from 'recoil'

export const modalOnDiscardChangesThemeState = atom({
  key: 'modalOnDiscardChangesThemeState',
  default: false
})
